export default __webpack_public_path__ + "static/media/100_38807.c0daa1a6.jpg";